import axios from "axios";

class HttpInstance {
  constructor(baseUrl = "/", tokenKey) {
    this.baseUrl = baseUrl;
    this.timeout = 15000;
    this.tokenKey = tokenKey;

    return this.init()
  }

  init() {
    const instance = axios.create({
      baseURL: this.baseUrl,
      timeout: this.timeout,
    });

    instance.interceptors.request.use((config) => {
      if (this.tokenKey) {
        let tk = localStorage.getItem(this.tokenKey);
        config.headers["Authorization"] = "Bearer " + tk;
      }
      return config;
    });

    instance.interceptors.response.use(
      response => {
        const { status, data } = response
        if (status === 200) {
          return (data)
        } else {
          return Promise.reject(response)
        }
      },
      error => {
        return Promise.reject(error)
      }
    );

    return instance;
  }
}
export default HttpInstance;



// WEBPACK FOOTER //
// ./src/api/base.js